import { SizeTypeTokens, IconTokens, IconSizeTokens, ColorTokens, FontSizeTokens, FontFamilyTokens, IconAlignmentTokens, } from '@voltmoney/schema';
import React, { memo } from 'react';
import { Pressable, View, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import ThemeProvider from '@voltmoney/theme';
import Icon from '../../icon/Icon';
import Space from '../../space/Space';
import Typography from '../../typography/Typography';
const HeaderScreen = ({ title, subTitle, triggerAction, onPress, action, isBackButton, trailIcon, needHelpIcon, logoutIcon, widgetItem, renderItem, needHelpAction, logoutAction, navigateToProfileAction, }) => {
    const theme = ThemeProvider.getTheme();
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    const handleProfileAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(View, { style: styles.container },
        React.createElement(View, { style: [styles.subContainer, { marginBottom: !!widgetItem ? 16 : 0 }] },
            React.createElement(View, { style: styles.content },
                isBackButton && (React.createElement(React.Fragment, null,
                    React.createElement(View, { style: styles.backIconContainer },
                        React.createElement(Pressable, { onPress: handleAction },
                            React.createElement(Icon, { name: IconTokens.ChevronLeft, size: IconSizeTokens.XL, color: ColorTokens.Grey_Night }))),
                    React.createElement(Space, { size: SizeTypeTokens.MD }))),
                React.createElement(Typography, { label: title + " ", fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, fontWeight: '400', fontSize: FontSizeTokens.MD }),
                React.createElement(Typography, { label: subTitle, numberOfLines: 1, fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Primary_100, fontWeight: '600', fontSize: FontSizeTokens.MD })),
            needHelpIcon && (React.createElement(View, { nativeID: 'bt_landingScreen_needHelp', style: {
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    alignSelf: 'center',
                    marginRight: 12,
                } },
                React.createElement(TouchableOpacity, { activeOpacity: 1, style: {
                        backgroundColor: '#F3F5FC',
                        borderRadius: 24,
                        height: 28,
                        paddingVertical: 6,
                        paddingHorizontal: 8,
                        flexDirection: 'row'
                    }, hitSlop: { top: 24, bottom: 24, left: 24, right: 24 }, onPress: () => needHelpAction() },
                    React.createElement(Icon, { name: IconTokens.Whatsapp, size: IconSizeTokens.MD }),
                    React.createElement(View, { style: {
                            marginLeft: 4
                        } },
                        React.createElement(Typography, { label: 'NEED HELP?', fontSize: FontSizeTokens.XXS, fontWeight: "600", lineHeight: 16, color: ColorTokens.Primary_100, fontFamily: FontFamilyTokens.Inter }))))),
            trailIcon && (React.createElement(View, { style: styles.iconContainer, nativeID: 'bt_landingScreen_profile' },
                React.createElement(Pressable, { onPress: () => navigateToProfileAction() },
                    React.createElement(Icon, { name: IconTokens.Account, size: IconSizeTokens.XXXXL, align: IconAlignmentTokens.right })))),
            false && (React.createElement(React.Fragment, null,
                React.createElement(View, { style: styles.iconContainer, nativeID: 'bt_landingScreen_logOut' },
                    React.createElement(TouchableOpacity, { onPress: () => logoutAction() },
                        React.createElement(Icon, { name: IconTokens.Logout, color: ColorTokens.Primary_100, size: IconSizeTokens.MD })))))),
        !!widgetItem &&
            !!renderItem &&
            renderItem(widgetItem)));
};
const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 16,
        paddingBottom: 12,
        paddingTop: Platform.OS === "ios" ? 46 : 20,
        shadowColor: '#D0D5DD',
        shadowOffset: {
            width: 0,
            height: 1,
        },
        shadowOpacity: 0.18,
        shadowRadius: 1.0,
        elevation: 6,
        backgroundColor: 'white',
    },
    subContainer: {
        justifyContent: 'flex-start',
        flexDirection: 'row',
        alignItems: 'center',
    },
    content: {
        flexDirection: 'row',
        flex: 1,
        alignItems: 'center',
    },
    backIconContainer: {
        alignContent: 'center',
        justifyContent: 'center',
        marginTop: 5
    },
    iconContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#F3F5FC',
        borderRadius: 100,
        padding: 8,
        height: 32,
        width: 32,
    },
});
export default memo(HeaderScreen);
export { HeaderScreen };
